export default {
  zIndex: {
    type: Number,
    default: null,
  },
  showSaveConfirm: {
    type: Boolean,
    default: false,
  },
  show: {
    type: Boolean,
    default: true,
  },
  menuAddChooseShow: {
    type: Boolean,
    default: false,
  },
  menuAddChooseName: {
    type: String,
    default: '添加',
  },
  menuAddChooseModalTitle: {
    type: String,
    default: '请选择',
  },
  menuAddChooseUrl: {
    type: String,
    default: '',
  },
  menuAddChooseIndex: {
    type: Boolean,
    default: true,
  },
  menuAddChooseRequestMethod: {
    type: String,
    default: 'post',
  },
  // 请求参数,json格式或者对象
  menuAddChooseRequestParam: {
    type: [String, Object],
    default: null,
  },
  menuAddChooseSearchKey: {
    type: String,
    default: 'keyword',
  },
  menuAddChooseTableColumnDef: {
    type: Array,
    default: () => {
      return [
        {
          prop: 'code',
          label: '编码',
        },
        {
          prop: 'name',
          label: '名称',
        },
      ]
    },
  },
  menuAddChooseplaceholder: {
    type: String,
    default: '请输入',
  },
  value: {
    type: Object,
    default: () => {},
  },
  initClearItems: { type: Boolean, default: false },
  //将表单中的某个值设置为null
  setPathNull: {
    type: String,
  },

  // 设置侧滑框底部按钮文字为可配置
  isShowDraft: {
    type: Boolean,
    default: false,
  },
  sideModalBtnDraft: {
    type: String,
    default: '保存',
  },
  draftParam: {
    // 需要和formData结构体合并到一起的传入参数
    type: Object,
    default: () => {},
  },
  // 设置侧滑框底部按钮文字为可配置
  sideModalBtn: {
    type: String,
    default: '确定',
  },
  anewAndSure: {
    type: Boolean,
    default: false,
  },
  anewSideModalBtn: {
    type: String,
    default: '确定并继续',
  },
  // 获取编辑内容
  urlGetOfEdit: {
    type: String,
    default: null,
  },
  methodsGet: {
    type: String,
    default: 'get',
  },
  parameterGet: {
    type: Object,
    default: () => {},
  },
  otherParameter: {
    type: Object,
    default: () => {},
  },
  sideModalWidth: {
    type: [String, Number],
    default: null,
  },
  sideModalSecondWidth: {
    type: [String, Number],
    default: null,
  },
  urlSave: {
    type: String,
    default: null,
  },
  saveParam: {
    type: Object,
    default: () => {},
  },
  urlSaveKey: {
    type: String,
    default: null,
  },
  // 表单配置请求URL,.有值时，配置formItemsDef 失效
  urlItemsDef: {
    type: String,
    default: null,
  },
  // 列表定义配置
  formItemsDef: {
    type: [Array, Object],
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
  needConfirm: {
    type: Boolean,
    default: false,
  },
  footerHide: {
    type: Boolean,
    default: false,
  },
  // 设置左边距可配
  paddingLeft: {
    type: Number,
    default: 20,
  },
  // 设置右边距可配
  paddingRight: {
    type: Number,
    default: 20,
  },
  // 表单Form配置
  propsForm: {
    type: Object,
    default: () => {
      return {
        // 是否开启行内表单模式
        inline: false,
        // 表单域标签的位置，可选值为 left、right、top
        labelPosition: 'top',
        // //表单域标签的宽度，所有的 FormItem 都会继承 Form 组件的 label-width 的值
        //  labelWidth:0,
        // 是否显示校验错误信息
        showMessage: true,
        // 原生的 autocomplete 属性，可选值为 off 或 on
        autocomplete: 'off',
      }
    },
  },
  // 是否需要confirm
  needPGMessageConfirm: {
    type: Boolean,
    default: false,
  },
  needMessage: {
    type: Boolean,
    default: true,
  },
  store: {
    type: Object,
    default: null,
  },
  useBackCount: {
    type: String,
    default: null,
  },
  formatOfUrlSave: {
    type: Array,
    default: null,
  },
  dataKeyOfUrlSave: {
    type: String,
    default: null,
  },
  paramKeyOfUrlSave: {
    type: String,
    default: null,
  },
  dispatchComponent: {
    type: Object,
    default: null,
    /* 示例
         {
             componentName:'',
             eventName:'',
             repeatFilter:{
                 key:'',
                 text:''
             }
         }
        */
  },
  progressParam: {
    // 如有有异步任务接口，配置异步任务转圈的样式
    type: Object,
    default: () => ({}),
  },
  sureParam: {
    // 需要和formData结构体合并到一起的传入参数
    type: Object,
    default: () => {},
  },
  btnConfirmObj: {
    //点击确定按钮出现弹窗中的标题，内容支持可配置
    type: Object,
    default: () => {
      return {
        title: '确认提示',
        content: '确认提交？',
      }
    },
  },
  getCompleteRes: {
    // 获取完整的 执行动作返回数据
    type: Boolean,
    default: false,
  },
  // 点击确认按钮后执行接口报400，需要展示弹窗提示，点击确定后正常执行下面后面的动作
  identifyAndContinue: {
    type: Boolean,
    default: false,
  },
  btnConfirmIsDynamic: {
    //点击确定按钮出现弹窗中内容支持表达式
    type: Boolean,
    default: false,
  },
  isAssignParamKeyOfUrlSave: {
    // 保存时，是否允许指定传递 formData 上的某个属性的值
    type: Boolean,
    default: false,
  },
  /**
   * @name 保存并继续的接口调用地址
   * @description #6354
   */
  anewAndSureUrlSave: {
    type: String,
  },
  /**
   * @name 表单初始化指定属性的数据
   * @description #7758
   * [
   *    {
   *       "path": "order.exeDepartment",
   *       "value": "{{CurrentTicket.department}"
   *    },
   *    {
   *       "path": "order.exeMember",
   *       "value": "{{CurrentTicket.member}"
   *    }
   * ]
   */
  changeFields: {
    type: Array,
  },
  //   ---------------------------------需求：6128 ------------------------
  // 表单初始化的数据
  begFormData: {
    type: Object,
    default: null,
  },
  // 表单数据是否需要包装成数组
  formDataIsArray: {
    type: Boolean,
    default: false,
  },
  // 是否需要将paramConnectWithFormData参数和formData结构体合并到一起提交，默认支持
  paramConnectWithFormData: {
    type: Object,
    default: null,
  },
  //   ---------------------------------需求：6807  ------------------------
  // 设置 anewAndSure 请求需要的接口信息，本次只扩展url
  anewAndSureReqObj: {
    type: Object,
    default: null,
  },
  secondSave: {
    type: String,
    default: '',
  },

  /** 7137 【按采购入库单添加】
    "sureOtherParameter": {
      "path": "order.procedure.key",
      "val": "CHECK_B2"
    }
   */
  sureOtherParameter: {
    type: Object,
    default: () => {},
  },
  // #8346 自定义参数处理
  customParamFunc: {
    type: Function,
  },
  //   ---------------------------------需求：7134  ------------------------
  // 支持提交前触发一个方法，beforeSubmitAction方法名
  beforeSubmitAction: {
    type: String,
    default: '',
  },
  transfer: {
    type: Boolean,
    default: true,
  },
  //本地缓存的key
  cacheKey: {
    type: String,
    default: '',
  },
  transformField: Object,
  changePath: {
    type: String,
    default: null,
  },
  //是否合并begFormData 到formData
  needMergFormData: {
    type: Boolean,
    default: false,
  },
  sideModalBodyOverflowY: {
    type: String,
  },
  // 关闭强制提交时弹出确认窗口, errors 中 level == 1 和值为 closeForceSubmitConfirmMsg == true 时生效
  closeForceSubmitConfirmMsg: {
    type: Boolean,
    default: false,
  },
  // 不取缓存的字段集
  noCaches: {
    type: Array,
    default() {
      return []
    },
  },
  labelTip: {
    type: String,
    default: '',
  },
}
